export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认外部转账后，系统将自动从您的账户向交易者账户进行内部转账，交易将完成。"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认收到转账并完成交易？"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["是的，确认"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["否，保持活动"])}
}